import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import DetailBPPPage from '@/components/pages/backoffice/_klb-penyuluh/_kecamatan/containers/DetailBPPPage'

export const Route = createFileRoute(
  '/_backoffice/klb-penyuluh/kecamatan/$bppId/'
)({
  component: DetailBPPPage,
  validateSearch: z.object({
    tab: z.string().optional().default('profile')
  })
})
